import isEqual from 'lodash.isequal';
// api
import { api } from 'redux-store/api';
import {
  TGetCompanyLocationsResponse,
  IGetCompanyLocationsArgs,
  ICompanyLocation,
  ICreateCompanyLocationBody,
  IUpdateCompanyLocationBody,
} from './';
import { getCompanyId } from 'utils/helpers';

enum Endpoints {
  COMPANY_LOCATIONS = 'company-selection-room',
}

export const companyLocationsApi = api.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getCompanyLocations: query<TGetCompanyLocationsResponse, IGetCompanyLocationsArgs>({
      query: (params) => ({
        url: Endpoints.COMPANY_LOCATIONS,
        params,
      }),

      serializeQueryArgs: () => {
        const companyId = getCompanyId();
        return { companyId };
      },

      merge: (currentCache, newCache, { arg: { cursor } }) => {
        if (!cursor) {
          return newCache;
        }
        return {
          meta: newCache.meta,
          items: [...currentCache.items, ...newCache.items],
        };
      },

      forceRefetch: ({ currentArg, previousArg }) => {
        return !isEqual(currentArg, previousArg);
      },

      keepUnusedDataFor: 0,
    }),

    createCompanyLocation: mutation<ICompanyLocation, ICreateCompanyLocationBody>({
      query: (body) => ({
        url: Endpoints.COMPANY_LOCATIONS,
        body,
        method: 'POST',
      }),

      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const companyId = getCompanyId();
        try {
          const { data: response } = await queryFulfilled;

          dispatch(
            companyLocationsApi.util.updateQueryData(
              'getCompanyLocations',
              // @ts-ignore
              { companyId },
              (draft) => {
                if (draft?.items) {
                  draft.items.unshift(response);
                }
              }
            )
          );
        } catch (e) {}
      },
    }),

    updateCompanyLocation: mutation<ICompanyLocation, IUpdateCompanyLocationBody>({
      query: (body) => ({
        url: Endpoints.COMPANY_LOCATIONS,
        body,
        method: 'PATCH',
      }),

      onQueryStarted: async ({ status }, { queryFulfilled, dispatch }) => {
        const companyId = getCompanyId();

        try {
          const { data: response } = await queryFulfilled;

          dispatch(
            companyLocationsApi.util.updateQueryData(
              'getCompanyLocations',
              // @ts-ignore
              { companyId },
              (draft) => {
                if (draft?.items) {
                  if (status) {
                    draft.items = draft.items.filter(({ id }) => id !== response.id);
                  } else {
                    const locationIndex = draft.items.findIndex(({ id }) => id === response.id);
                    if (locationIndex >= 0) {
                      draft.items[locationIndex] = response;
                    }
                  }
                }
              }
            )
          );
        } catch (e) {}
      },
    }),
  }),
});

export const {
  useGetCompanyLocationsQuery,
  useLazyGetCompanyLocationsQuery,
  useCreateCompanyLocationMutation,
  useUpdateCompanyLocationMutation,
} = companyLocationsApi;
